import { TabProps } from 'grommet'
import React, { PureComponent } from 'react'
import { StyledTab } from './styles'

export default class Tab extends PureComponent<TabProps & Omit<JSX.IntrinsicElements['button'], 'title'>> {
  render() {
    return <StyledTab {...this.props}>{this.props.children}</StyledTab>
  }
}
